<template>
  <div :class="'my-3 info-required-fields' + additionalCssClasses">
    <b>{{ infoText }}</b>
    &nbsp;
    <span>{{ text }}</span>
  </div>
</template>

<script>
import { domainStore } from '@/store/domain-store';
import { computed } from 'vue';

export default {
  name: 'InfoRequiredFields',
  props: {
    additionalCssClasses: {
      required: false,
      type: String,
      default: '',
    },
    text: {
      required: false,
      type: String,
    },
  },

  setup(props) {
    const infoText = computed(() => {
      if (props.text) {
        return props.text;
      }
      return domainStore.translate('general.message.form-notice-required-fields');
    });

    return {
      infoText,
    };
  },
};
</script>

<style></style>
